import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { PatientBillInfoDto } from "../../../../api-client";
import { isPaymentBlocked } from "./sepaBill";
import { useActiveRcurMandates } from "../hooks/useActiveRcurMandates";
import PerLastschriftButton from "./PerLastschriftButton";
import SepaRefundDialog from "./SepaRefundDialog";

const UEBERBEZAHLT_CLASS =
  "h-8 rounded-lg border-0 bg-gradient-to-b from-[#c4a95f] to-[#a5893f] px-3 text-sm font-semibold text-white shadow-sm transition-all duration-200 hover:from-[#b89f54] hover:to-[#8f7333] active:scale-[0.97]";

interface Props {
  bill: PatientBillInfoDto;
  patientId: number;
}

/**
 * SEPA actions for a single bill row:
 *   - due > 0  → "per Lastschrift" against an ACTIVE recurring mandate (if one exists).
 *                One-off ("Einmal Lastschrift") lives in the "Zahlen" modal instead.
 *   - due < 0  → "Überbezahlt" (SEPA/cash refund).
 *   - due == 0 → nothing (the parent shows the paid badge).
 */
const SepaBillActions: React.FC<Props> = ({ bill, patientId }) => {
  const [refundOpen, setRefundOpen] = useState(false);

  // ACTIVE recurring mandates that match this bill's creditor account.
  const activeRcurMandates = useActiveRcurMandates(patientId, bill.accountId);

  const blocked = isPaymentBlocked(bill);

  if (bill.dueAmount < 0) {
    return (
      <>
        <Button
          size="sm"
          className={UEBERBEZAHLT_CLASS}
          disabled={blocked}
          onClick={() => setRefundOpen(true)}
        >
          Überbezahlt
        </Button>
        <SepaRefundDialog
          bill={bill}
          patientId={patientId}
          open={refundOpen}
          onOpenChange={setRefundOpen}
        />
      </>
    );
  }

  if (bill.dueAmount > 0 && activeRcurMandates.length > 0) {
    return (
      <PerLastschriftButton
        bill={bill}
        patientId={patientId}
        mandates={activeRcurMandates}
        disabled={blocked}
      />
    );
  }

  return null;
};

export default SepaBillActions;
